import React, {FunctionComponent} from "react";
import {IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, useTheme} from "@mui/material";
import {MetadataCategoryCode} from "../../../book/MetadataCategoryCode";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {Link} from "react-router-dom";
import {AppRoute} from "../../../book/AppRoute";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {useTranslation} from "react-i18next";
import {Product} from "../../../api/GovernanceToolApi";

export const ProductsTable: FunctionComponent<ProductsTableProps> = props => {
    const {t} = useTranslation();
    const theme = useTheme();

    return <Table aria-label="products">
        <TableHead>
            <TableRow>
                <TableCell>{t("Product name")}</TableCell>
                <TableCell>{t("Version")}</TableCell>
                <TableCell sx={{
                    [theme.breakpoints.down('lg')]: {
                        display: 'none'
                    }
                }}>{t("Project configuration")}</TableCell>
                <TableCell sx={{
                    [theme.breakpoints.down('sm')]: {
                        display: 'none'
                    }
                }}>Market</TableCell>
                <TableCell sx={{
                    [theme.breakpoints.down('sm')]: {
                        display: 'none'
                    }
                }}>HW Platform</TableCell>
                <TableCell sx={{
                    [theme.breakpoints.down('sm')]: {
                        display: 'none'
                    }
                }}>Scope</TableCell>
                <TableCell sx={{
                    [theme.breakpoints.down('md')]: {
                        display: 'none'
                    }
                }}>Subsidiary</TableCell>
                <TableCell/>
            </TableRow>
        </TableHead>
        <TableBody>
            {props.products.map(p => {
                const findMetadata = (category: string) => (p.productProperties ?? []).filter(p => p.category?.toLowerCase() === category).map(p => p.value).join(" - ");
                const projectConfiguration = findMetadata("project configuration");
                const market = findMetadata(MetadataCategoryCode.market);
                const hwplatform = findMetadata(MetadataCategoryCode.hwplatform);
                const scope = findMetadata(MetadataCategoryCode.scope);
                const subsidiary = findMetadata(MetadataCategoryCode.subsidiary);

                return <TableRow key={p.id}>
                    <TableCell scope="row">
                        {p.name}
                    </TableCell>
                    <TableCell scope="row">
                        {!p.isStableRelease &&
                            <Tooltip title="Current release"><span>{p.version}*</span></Tooltip>}
                        {p.isStableRelease && <span>{p.version}</span>}
                    </TableCell>
                    <TableCell scope="row"
                               sx={{
                                   [theme.breakpoints.down('lg')]: {
                                       display: 'none'
                                   }
                               }}>
                        {projectConfiguration}
                    </TableCell>
                    <TableCell scope="row"
                               sx={{
                                   [theme.breakpoints.down('sm')]: {
                                       display: 'none'
                                   }
                               }}>
                        {market}
                    </TableCell>
                    <TableCell scope="row"
                               sx={{
                                   [theme.breakpoints.down('sm')]: {
                                       display: 'none'
                                   }
                               }}>
                        {hwplatform}
                    </TableCell>
                    <TableCell scope="row"
                               sx={{
                                   [theme.breakpoints.down('sm')]: {
                                       display: 'none'
                                   }
                               }}>
                        {scope}
                    </TableCell>
                    <TableCell scope="row"
                               sx={{
                                   [theme.breakpoints.down('md')]: {
                                       display: 'none'
                                   }
                               }}>
                        {subsidiary}
                    </TableCell>
                    <TableCell scope="row" align='right'>
                        {props.showDeleteProductButton && <IconButton
                            title={t("searchProductDelete", {productName: p.name})}
                            size="small"
                            color="primary"
                            aria-label={t("delete product")}
                            onClick={() => props.onDelete(p)}>
                            <DeleteForeverIcon/>
                        </IconButton>}
                        <IconButton
                            title={t("searchProductOpenDetails", {productName: p.name})}
                            size="small"
                            aria-label={t("product details")}
                            component={Link}
                            to={`${AppRoute.ProductDetails.replace(":productId", p.id)}`}>
                            <NavigateNextIcon/>
                        </IconButton>
                    </TableCell>
                </TableRow>;
            })}
        </TableBody>
    </Table>;
}

export interface ProductsTableProps {
    products: Product[];
    showDeleteProductButton?: boolean;
    onDelete: (productId: Product) => void;
}